import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { deleteAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const deleteLandedCostVendorHistory = async (payload = []) => {
  const tokenInfo = await getJWTToken();

  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostUploadHistoryDelete}`;

  const response = await deleteAPI(apiUrl, tokenInfo, JSON.stringify(payload));

  if (!response) {
    AlertManager.error("Unable to delete landed cost history.");
    return null;
  }

  if (response.ok) {
    AlertManager.success("Selected rows deleted successfully.", { contactSupport: false });
    return response;
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to delete landed cost history.");
  return null;
};
